import type {OperationsStatus} from "../api/client";
import type {AuthenticatedUser} from "../auth/AuthContext";

export function StatusRail({
  status,
  user,
  onLogout
}: {
  status: OperationsStatus;
  user: AuthenticatedUser;
  onLogout(): void;
}) {
  return (
    <section className="status-rail" aria-label="Control plane safety status" tabIndex={0}>
      <div><span>Environment</span><strong>{status.environment}</strong></div>
      <div title={status.execution.detail}><span>Execution</span>
        <strong className={status.execution.availability === "UNAVAILABLE" ? "deny-text" : "safe"}>
          {executionLabel(status.execution.mode)}
        </strong>
        <small>{executionDetail(status)}</small>
      </div>
      <div><span>Human gate</span><strong>Named approver</strong></div>
      <div><span>Platform</span><strong className={status.health === "UP" ? "safe-dot" : "deny-text"}>{status.health}</strong></div>
      <div><span>Signed in</span><strong>{user.displayName}</strong></div>
      <button type="button" onClick={onLogout}>Sign out</button>
    </section>
  );
}

function executionLabel(mode: OperationsStatus["execution"]["mode"]): string {
  switch (mode) {
    case "IN_PROCESS": return "In-process";
    case "CONTROL_PLANE": return "Control plane";
    case "LANE": return "Execution lane";
  }
}

function executionDetail(status: OperationsStatus): string {
  const execution = status.execution;
  if (!execution.laneRequired) return execution.availability.toLowerCase();
  const identity = execution.laneIdentity ?? "lane identity unavailable";
  return `${identity} · ${execution.laneStatus.toLowerCase()}`;
}
